module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_7005.329295ea.png";